/* GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Produced by tools/gen-pricing-lib.py from assets/bt-customizer.js.
 * The quick-quote page must quote exactly what the customizer charges, so the
 * pricing functions below are EXTRACTED verbatim from the customizer rather than
 * reimplemented. If pricing logic changes in bt-customizer.js, re-run:
 *     python3 tools/gen-pricing-lib.py
 * and verify with:
 *     node tools/test-pricing-parity.js
 *
 * Exposes window.BTPricing = { setRates, setDiscounts, computePrice }.
 * Rates come from the SAME assets/pricing-rates.json the customizer loads.
 */
(function(){
  "use strict";
  var DISCOUNTS = null;
  var PRICE_RATES = null;
  var SHIP_SET = null;

  var ZIP3_RANGES=[
      [5,5,'NY'],[6,7,'PR'],[8,8,'VI'],[9,9,'PR'],[10,27,'MA'],[28,29,'RI'],[30,38,'NH'],[39,49,'ME'],
      [50,59,'VT'],[60,69,'CT'],[70,89,'NJ'],[90,98,'AE'],[100,149,'NY'],[150,196,'PA'],[197,199,'DE'],
      [200,205,'DC'],[206,219,'MD'],[220,246,'VA'],[247,268,'WV'],[270,289,'NC'],[290,299,'SC'],
      [300,319,'GA'],[320,339,'FL'],[340,340,'AA'],[341,349,'FL'],[350,369,'AL'],[370,385,'TN'],
      [386,397,'MS'],[398,399,'GA'],[400,427,'KY'],[430,459,'OH'],[460,479,'IN'],[480,499,'MI'],
      [500,528,'IA'],[530,549,'WI'],[550,567,'MN'],[570,577,'SD'],[580,588,'ND'],[590,599,'MT'],
      [600,629,'IL'],[630,658,'MO'],[660,679,'KS'],[680,693,'NE'],[700,714,'LA'],[716,729,'AR'],
      [730,749,'OK'],[750,799,'TX'],[800,816,'CO'],[820,831,'WY'],[832,838,'ID'],[840,847,'UT'],
      [850,865,'AZ'],[870,884,'NM'],[889,898,'NV'],[900,961,'CA'],[962,966,'AP'],[967,968,'HI'],
      [969,969,'GU'],[970,979,'OR'],[980,994,'WA'],[995,999,'AK']
    ];

  function computePrice(input){
      var r2=function(n){return Math.round(n*100)/100;};
      var method=input.method||'screenprint';
      // Shared-design pooling: poolQ drives the price TIER (combined group qty); each product still
      // pays for its own pieces. chargeSetup=false skips screen/vector/digitizing (charged once per group).
      var poolQ=input.poolQty||input.totalPieces;
      var chargeSetup=(input.chargeSetup===false)?false:true;
      // Distinct uploaded files placed across all views. Screen print bills one vectoring
      // fee per file; embroidery bills one digitizing fee per file for the same reason —
      // each separate piece of artwork is its own setup job. Shared so the two can't drift.
      var rawFiles=Math.max(0,parseInt(input.vectorFiles,10)||0);
      var artFiles=Math.max(1,rawFiles);   // vectoring: every screen print needs vector art
      var digiUnits=Math.max(1,rawFiles+Math.max(0,parseInt(input.textOnlyLocations,10)||0));  // digitizing: each design AND each text-only location
      var printBase=0,placement=0,inkUp=0,setupFees=0,setupUnderlays=0,embellish=0,digitizing=0,lines=[];
      if(method==='dtf'||method==='dtg'){
        var cfg=PRICE_RATES[method];
        var tD=function(q){ var i=cfg.qtyTiers.findIndex(function(t){return q>=t.min&&(t.max==null||q<=t.max);}); return i<0?0:i; };
        var dtgColors=null, dtgTotal=0;
        if(method==='dtg'){
          var ov=input.shadeOverride?(input.shade==='dark'?'dark':'white'):null;
          dtgColors=(input.colorSizes||[]).map(function(cs){ var q=0; for(var k in cs.sizes){ q+=parseInt(cs.sizes[k],10)||0; } return {shade:ov||shadeForColor(cs.color), pieces:q}; });
          dtgTotal=dtgColors.reduce(function(s,c){return s+c.pieces;},0);
          if(!dtgTotal){ dtgColors=[{shade:ov||input.shade||'white', pieces:input.totalPieces}]; dtgTotal=input.totalPieces||1; }
        }
        input.locations.forEach(function(loc){
          var lq=loc.qty>0?Math.min(loc.qty,input.totalPieces):input.totalPieces;
          var ti=tD(poolQ), s=cfg.sizes.find(function(x){return x.id===loc.size;});
          var per,base,dgL,dgD,dgPW,dgPK;
          if(method==='dtg'){
            dgPW=r2((s?s.white[ti]:0)+cfg.qtyTiers[ti].markup); dgPK=r2((s?s.dark[ti]:0)+cfg.qtyTiers[ti].markup);
            var lightAtLoc=0; dtgColors.forEach(function(c){ if(c.shade==='white') lightAtLoc+=Math.round(lq*(c.pieces/dtgTotal)); });
            lightAtLoc=Math.min(lq,Math.max(0,lightAtLoc)); var darkAtLoc=lq-lightAtLoc;
            dgL=lightAtLoc; dgD=darkAtLoc;
            base=r2(dgPW*lightAtLoc+dgPK*darkAtLoc); per=lq>0?r2(base/lq):dgPW;
          } else {
            per=r2((s?s.cost[ti]:0)+cfg.qtyTiers[ti].markup); base=r2(per*lq);
          }
          var plc=loc.standard?0:r2(base*(cfg.nonStandardPlacementPct||0)/100);
          printBase+=base; placement+=plc;
          var sLabel=(s&&s.label)||loc.size;
          lines.push({label:sLabel,perPiece:per,base:base,placement:plc,standard:loc.standard,qty:lq,light:dgL,dark:dgD,perW:dgPW,perK:dgPK});
        });
      } else if(method!=='embroidery'){
        var sp=PRICE_RATES.screenprint;
        var tS=function(q){ var i=sp.qtyTiers.findIndex(function(t){return q>=t.min&&(t.max==null||q<=t.max);}); return i<0?0:i; };
        var webS=function(colors,q){ var ti=tS(q); var row=sp.cost[String(Math.min(colors,sp.maxColors))]; return r2((row?row[ti]:0)+sp.qtyTiers[ti].markup); };
        var totalScreens=0;
        input.locations.forEach(function(loc){
          var lq=loc.qty>0?Math.min(loc.qty,input.totalPieces):input.totalPieces;
          var per=webS(loc.colors,poolQ), base=r2(per*lq);
          var plc=loc.standard?0:r2(base*sp.nonStandardPlacementPct/100);
          var inkRec=loc.ink?sp.specialtyInks.find(function(i){return i.id===loc.ink;}):null;
          var ink=inkRec?r2(base*inkRec.pct/100):0;
          var under=isBlackOnlyLoc(loc.colorList,loc.colors)?0:1;   // +1 white-underlay screen per location unless black-only
          printBase+=base; placement+=plc; inkUp+=ink; totalScreens+=loc.colors+under; setupUnderlays+=under;
          lines.push({label:loc.colors+'C',colors:loc.colors,underlay:under,perPiece:per,base:base,placement:plc,ink:ink,inkLabel:inkRec?inkRec.label:'',standard:loc.standard,qty:lq});
        });
        var freeS=(poolQ>=sp.screenFee.freeAtQty)?sp.screenFee.freeCount:0;
        setupFees=chargeSetup?r2(Math.max(0,totalScreens-freeS)*sp.screenFee.perColor):0;
      }
      if(method==='embroidery'){
        var em=PRICE_RATES.embroidery;
        var tEm=function(q){ var i=em.qtyTiers.findIndex(function(t){return q>=t.min&&(t.max==null||q<=t.max);}); return i<0?em.qtyTiers.length-1:i; };
        var costEm=function(st,q){ var ti=tEm(q); var band=em.stitchBands.find(function(b){return st<=b.maxStitch;});
          if(band) return band.cost[ti];
          var last=em.stitchBands[em.stitchBands.length-1]; return r2(last.cost[ti]+Math.ceil((st-last.maxStitch)/1000)*em.additional1k[ti]); };
        input.locations.forEach(function(loc){
          var lq=loc.qty>0?Math.min(loc.qty,input.totalPieces):input.totalPieces;
          var st=Math.max(1,parseInt(loc.stitches,10)||1);
          var per=r2(costEm(st,poolQ)+(em.markup||0)), base=r2(per*lq);
          var plc=loc.standard?0:r2((em.nonStandardPlacementPerPiece||0)*lq);
          var embPer=0; (em.embellishments||[]).forEach(function(eb){ if(loc[eb.id]) embPer+=eb.per1000*(st/1000); });
          var emb=r2(embPer*lq);
          printBase+=base; placement+=plc; embellish+=emb;
          lines.push({label:st.toLocaleString()+' st',stitches:st,perPiece:per,base:base,placement:plc,emb:emb,threads:loc.threads||'',standard:loc.standard,qty:lq});
        });
        digitizing=(input.embRepeat||!chargeSetup)?0:r2((em.digitizingFee||0)*digiUnits);
      }
      var discPct=0,discount=0,grp=input.premium?(input.discountTier||'normal'):discountGroupOf(input.productHandle);
      if(grp && PRICE_RATES.discountTiers[grp]){
        PRICE_RATES.discountTiers[grp].forEach(function(t){ if(input.garmentSubtotal>=t[0]) discPct=t[1]; });
        discount=r2(input.garmentSubtotal*discPct/100);
      }
      var garmentNet=r2(input.garmentSubtotal-discount);
      var ex=PRICE_RATES.extras, e=input.extras||{}, n=input.totalPieces;
      var bulky=(ex.bulkyTypes||[]).some(function(t){ return ((input.garmentType||'')+' '+(input.title||'')).toLowerCase().indexOf(t)>=0; });
      // Vector art fee is now AUTOMATIC on every screen-print order (no longer opt-in) — all
      // screen prints require vector art; customers can request a refund at checkout if they send their own.
      var vFiles=(method==='screenprint')?artFiles:0;   // one vector fee per distinct uploaded file placed
      var artPrep=!chargeSetup ? 0 : (method==='dtf' ? (e.transparentBg?(PRICE_RATES.dtf.transparentBgFee||0):0) : (method==='screenprint' ? (PRICE_RATES.screenprint.vectoringFee||0)*vFiles : 0));
      var poly=e.polyBag?r2((bulky?ex.polyBag.bulky:ex.polyBag.standard)*n):0;
      var tagRem=e.tagRemoval?r2((ex.tagRemoval||0)*n):0;
      var sizeStk=e.sizeStickers?r2((ex.sizeStickers||0)*n):0;
      var hangTag=e.hangTags?r2((ex.hangTags||0)*n):0;
      var split=e.splitShip?r2(ex.splitShipPerLocation*(e.splitShipLocations||1)):0;
      // Ink color change (screen print only): $10 per extra ink (different ink on dark vs light garments). Per product.
      var colorChange=(method==='screenprint'&&e.colorChange)?r2((PRICE_RATES.screenprint.colorChangeFee||0)*Math.max(1,parseInt(e.colorChangeInks,10)||1)):0;
      var shipCfg=PRICE_RATES.shipping||{};
      var heavyItem=input.premium?!!input.shipUpcharge:shipUpchargeOf(input.productHandle);
      var shipBase=heavyItem?(shipCfg.perPieceUpcharge||0):0;
      var shipRegionAdd=(shipBase>0 && input.shipTier)?(((shipCfg.regionSurcharge||{})[input.shipTier])||0):0;
      var shipPerPc=r2(shipBase+shipRegionAdd);
      var shipping=r2(shipPerPc*n);
      var sub=r2(garmentNet+printBase+placement+inkUp+setupFees+embellish+digitizing+artPrep+colorChange+poly+tagRem+sizeStk+hangTag+split+shipping);
      var gallery=input.galleryFeature?Math.min((PRICE_RATES.galleryDiscount||0),sub):0;
      var total=r2(sub-gallery);
      return {method:method,lines:lines,garmentSubtotal:input.garmentSubtotal,
        discPct:discPct,discount:discount,garmentNet:garmentNet,printBase:r2(printBase),placement:r2(placement),
        inkUp:r2(inkUp),setupFees:r2(setupFees),underlays:setupUnderlays,embellish:r2(embellish),digitizing:r2(digitizing),digiFiles:((chargeSetup&&method==='embroidery'&&!input.embRepeat)?digiUnits:0),artPrep:artPrep,vectorFiles:(chargeSetup?vFiles:0),colorChange:colorChange,poly:poly,tagRem:tagRem,sizeStk:sizeStk,hangTag:hangTag,split:split,shipping:shipping,shipPerPc:shipPerPc,shipRegionAdd:r2(shipRegionAdd),shipTier:input.shipTier||null,gallery:gallery,bulky:bulky,total:total};
    }

  function zipToState(zip){
      var m=String(zip||'').trim().match(/^(\d{3})\d{0,2}$/); if(!m) return null;
      var p=parseInt(m[1],10);
      for(var i=0;i<ZIP3_RANGES.length;i++){ if(p>=ZIP3_RANGES[i][0]&&p<=ZIP3_RANGES[i][1]) return ZIP3_RANGES[i][2]; }
      return null;
    }

  function discountGroupOf(handle){ return (DISCOUNTS&&DISCOUNTS.products&&DISCOUNTS.products[handle])||null; }

  function isBlackOnlyLoc(colorList, colors){
      if((colors||1)!==1) return false;
      return /\b(black|blk)\b/i.test(String(colorList||''));
    }

  function shadeForColor(colorName){
      var c=(colorName||'').toLowerCase(), words=(PRICE_RATES.dtg&&PRICE_RATES.dtg.lightColorWords)||[];
      for(var i=0;i<words.length;i++){ if(c.indexOf(words[i])>=0) return 'white'; }
      return 'dark';
    }

  function shipUpchargeOf(handle){ return !!(SHIP_SET&&SHIP_SET.has(handle)); }

  function configure(o){
    if(!o) return;
    if(o.DISCOUNTS !== undefined) DISCOUNTS = o.DISCOUNTS;
    if(o.PRICE_RATES !== undefined) PRICE_RATES = o.PRICE_RATES;
    if(o.SHIP_SET !== undefined) SHIP_SET = o.SHIP_SET;
  }

  window.BTPricing = {
    configure:    configure,
    setRates:     function(j){ configure({ PRICE_RATES: j }); },
    getRates:     function(){ return PRICE_RATES; },
    computePrice: function(input){ return computePrice(input); },
    zipToState:   function(z){ return zipToState(z); },
    isBulky:      function(h){ return shipUpchargeOf(h); },
    shipTierFor:  function(z){ var st=zipToState(z); return (st && PRICE_RATES && PRICE_RATES.shipping && PRICE_RATES.shipping.stateTier && PRICE_RATES.shipping.stateTier[st]) || null; },
    _fns:     ["computePrice", "zipToState", "discountGroupOf", "isBlackOnlyLoc", "shadeForColor", "shipUpchargeOf"],
    _globals: ["DISCOUNTS", "PRICE_RATES", "SHIP_SET"],
  };
})();
